export default __webpack_public_path__ + "static/media/jishologo.9f898d39.jpg";